<div class="detail-card">
  <div class="d-flex align-items-center gap-4">
    <div class="d-flex align-items-center gap-2 flex-grow-1">
      <div i18n class="detail-label">Annual Total</div>
      <button
        [ngbTooltip]="tooltip"
        aria-label="Annual Minimum information"
        i18n-aria-label
        type="button"
        class="no-style-button">
        <img
          [ngbTooltip]="tooltip"
          src="/assets/icons/grey/CircleQuestion.svg"
          alt=""
          [style.height.rem]="1.5"
          [style.width.rem]="1.5" />
      </button>
    </div>
    <div i18n class="detail-value">{{ annualTotal | currency }}</div>
  </div>
</div>

<ng-template #tooltip>
  <div i18n class="tooltip-text">
    This figure is an estimate of the recurring and lump sum payments still to be paid from the VB Account(s) this year
  </div>
</ng-template>
